class UploadTestCasesController {
    constructor(UploadTestCasesServiceApi, UtpUserTestSuitesServiceApi, UtpSimTestSuitesServiceApi, SettingsService, $timeout, Upload, toastr, UtpTestSuitesExServiceApi, ManageSimulatorServiceApi, UtpSimServiceApi, $window) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                selectedTester: null,
                selectedSim: null,
                selectedSuite: null,
                activeTestCases: [{ Id: -1, Name: '' }],
                excludedTestCases: [{ Id: -1, Name: '' }],
                showTesters: false,
                showError: false,
                errorMsg: '',
                uploadProgress: -1,
                maxUploadMb: 0,
                showSpinner: false,
                simulator: null,
                simHasICSQuestions: false,
                latestUploadedFileName: ''
            };
            this.data = {
                sims: [{ Id: -1, Name: '' }],
                testers: [{ Id: -1, Name: '' }],
                availableTestSuites: [{
                        ExpiryDate: null,
                        ExpiryClass: '',
                        ExpiryPopUpText: '',
                        Id: -1,
                        Name: '',
                        TestCaseVariableCount: 0,
                        SupportsMultitest: true
                        // expired: false,
                        // popupText: '',
                        // statusColour: '',
                    }],
                activeTestCases: [{ Id: -1, Name: '' }],
                excludedTestCases: [{ Id: -1, Name: '' }],
                testSuites: [{
                        ExpiryDate: null,
                        ExpiryClass: '',
                        ExpiryPopUpText: '',
                        Id: -1,
                        Name: '',
                        TestCaseVariableCount: 0,
                        SupportsMultitest: true
                        // expired: false,
                        // popupText: '',
                        // statusColour: ''
                    }]
            };
            this.selectedItems = this.resolve.selectedItems;
            // Test cases not provided from the parent component so go and get them
            let fetchTestCases = !this.selectedItems.testCases || !this.selectedItems.excludedTestCases;
            this.state = {
                selectedTester: this.selectedItems.selectedTester,
                selectedSim: this.selectedItems.selectedSim,
                selectedSuite: this.selectedItems.selectedSuite,
                activeTestCases: this.selectedItems.testCases,
                excludedTestCases: this.selectedItems.excludedTestCases,
                showTesters: this.selectedItems.showTesters,
                showError: false,
                errorMsg: '',
                uploadProgress: -1,
                maxUploadMb: 0,
                showSpinner: true,
                simulator: null,
                simHasICSQuestions: false,
                latestUploadedFileName: ''
            };
            this.UploadTestCasesService.getLatestUploadedFileName(this.state.selectedSuite.Id, this.state.selectedTester.Id, this.state.selectedSim.Id)
                .then((response) => {
                this.state.latestUploadedFileName = response.data;
            });
            this.SettingsService.getCachedSettings().then((response) => {
                this.state.maxUploadMb = response.MaxUploadMb;
            });
            this.UtpSimServiceApi.simHasICSQuestions(this.state.selectedSim.Id, this.state.selectedTester.Id)
                .then((response) => {
                this.state.simHasICSQuestions = response.data;
                return this.ManageSimulatorServiceApi.getSimulatorById(this.state.selectedSim.Id, this.state.selectedTester.Id);
            })
                .then((response) => {
                this.state.simulator = response.data;
                if (fetchTestCases) {
                    return this.UtpTestSuitesExServiceApi.getAllTestCases(this.state.selectedTester.Id, this.state.selectedSim.Id, this.state.selectedSuite.Id)
                        .then((response) => {
                        this.state.activeTestCases = response.data.ActiveTestCases;
                        this.state.excludedTestCases = response.data.ExcludedTestCases;
                        this.data.activeTestCases = response.data.ActiveTestCases;
                        this.data.excludedTestCases = response.data.ExcludedTestCases;
                        this.state.showSpinner = false;
                    });
                }
                else {
                    return undefined;
                }
            })
                .then(() => {
                this.state.showSpinner = false;
            });
        };
        this.addTestCase = (testCase) => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.UserTestSuiteService.addTestCase(req).then((response) => {
                    if (response.data.Errors != null && response.data.Errors.length > 0) {
                        this.state.errorMsg = response.data.Errors[0];
                        this.toastr.info(this.state.errorMsg);
                    }
                    else {
                        this.state.activeTestCases = response.data.ActiveTestCases;
                        this.state.excludedTestCases = response.data.ExcludedTestCases;
                    }
                }, (response) => {
                    this.state.showError = true;
                    if (response.data.ExceptionMessage !== null && response.data.ExceptionMessage !== undefined && response.data.ExceptionMessage !== '') {
                        this.state.errorMsg = response.data.ExceptionMessage;
                    }
                    else {
                        this.state.errorMsg = 'Error occurred in addition ';
                    }
                });
            }
            else {
                let req = {
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.SimTestSuiteService.addTestCase(req).then((response) => {
                    this.data.activeTestCases = response.data.ActiveTestCases;
                    this.data.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        // Method to remove test case from Active to Excluded and call WebApi
        this.removeTestCase = (testCase) => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.UserTestSuiteService.removeTestCase(req).then((response) => {
                    this.state.activeTestCases = response.data.ActiveTestCases;
                    this.state.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
            else {
                let req = {
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.SimTestSuiteService.removeTestCase(req).then((response) => {
                    this.data.activeTestCases = response.data.ActiveTestCases;
                    this.data.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        // Include all TestCases
        this.includeAllTestCases = () => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            // simId, testSuiteId, userId
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: null
                };
                this.UploadTestCasesService.includeAllTestCases(req).then((response) => {
                    this.state.activeTestCases = response.data.ActiveTestCases;
                    this.state.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        // Exclude all TestCases
        this.excludeAllTestCases = () => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            // simId, testSuiteId, userId
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: null
                };
                this.UploadTestCasesService.excludeAllTestCases(req).then((response) => {
                    this.state.activeTestCases = response.data.ActiveTestCases;
                    this.state.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        /////////////////// End Add / Exclude TestCases ///////////////////
        /////////////////// File Upload Methods ///////////////////
        // Hook method to catch file upload browser dialog
        this.uploadTestCase = (files) => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            // Ensure there is one file selected
            if (files !== null) {
                let fac = this.checkFileSizes(files);
                this.uploadFiles(fac.validFiles);
            }
            else {
                this.state.showError = true;
                this.state.errorMsg = 'Could not determine file uploaded!\nPlease select a file and try again!';
            }
        };
        // Upload file method to process file and send to WebApi
        this.uploadFiles = (files) => {
            // files = files;
            if (angular.isUndefined(files)) {
                return;
            }
            // Test length should be 1
            if (files.length === 1) {
                let requestDto = {
                    // Get first file as only allowing one upload at a time
                    Files: files[0]
                };
                // Test for User TestSuites (not Sim TestSuites)
                if (this.state.showTesters) {
                    if (this.checkFileExtension(files[0])) {
                        // Upload file to the WebApi
                        this.uploadFileToWebApi(requestDto, this.state.selectedSuite.Id, this.state.selectedTester.Id, this.state.selectedSim.Id);
                    }
                    else {
                        this.state.showError = true;
                        this.state.errorMsg = "Please select files with extension 'tse', 'zip', 'xml', 'xlsx' or 'xlsm'";
                        this.toastr.info(this.state.errorMsg);
                    }
                }
                files = null;
            }
        };
        // Upload File to the Web Api method
        this.uploadFileToWebApi = (requestDto, testSuiteId, userId, simId) => {
            // Upload file to the WebApi
            this.Upload.upload({
                method: 'POST',
                url: 'api/UploadTestCases/UploadTestCase?testSuiteId=' + testSuiteId + '&userId=' + userId + '&simId=' + simId,
                data: requestDto,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
            })
                .then((response) => {
                if (response.data.ActiveTestCases !== null && response.data.ActiveTestCases.length > 0) {
                    this.state.activeTestCases = response.data.ActiveTestCases;
                    this.state.excludedTestCases = response.data.ExcludedTestCases;
                    this.state.uploadProgress = -1;
                    // refresh the latestUploadedFileName
                    this.UploadTestCasesService.getLatestUploadedFileName(this.state.selectedSuite.Id, this.state.selectedTester.Id, this.state.selectedSim.Id)
                        .then((response) => {
                        this.state.latestUploadedFileName = response.data;
                    });
                }
                else {
                    this.state.showError = true;
                    this.state.errorMsg = 'File selected does not appear to be for this TestSuite.\nYou may have selected incorrect file or incorrect TestSuite.\nPlease try again.';
                    this.state.uploadProgress = -1;
                }
                this.timeout(() => {
                    this.state.uploadProgress = -1;
                });
            }, (response) => {
                this.state.showError = true;
                this.state.uploadProgress = -1;
                if (response.data.ExceptionMessage !== null && response.data.ExceptionMessage !== undefined && response.data.ExceptionMessage !== '') {
                    this.state.errorMsg = response.data.ExceptionMessage;
                }
                else {
                    this.state.errorMsg = 'Error occurred uploading file ';
                }
            }, (evt) => {
                let progress = Math.min(100, (100.0 * evt.loaded / evt.total));
                this.state.uploadProgress = progress;
            });
        };
        this.downloadLatestUploadedFileTooltip = () => {
            if (this.state.uploadProgress !== -1)
                return 'Please wait for the file upload to complete';
            else if (!this.state.latestUploadedFileName)
                return 'No test scope file to download';
            else
                return 'Download latest uploaded test scope file:' + this.state.latestUploadedFileName;
        };
        this.downloadLatestUploadedFile = () => {
            let url = `api/UploadTestCases/DownloadLatestFile?testSuiteId=${this.state.selectedSuite.Id}&userId=${this.state.selectedTester.Id}&simId=${this.state.selectedSim.Id}`;
            this.window.location.href = url;
            this.toastr.info('Download of latest uploaded test scope file started...');
        };
        this.exportTestScopeToCSVFile = () => {
            let url = `api/UploadTestCases/DownloadTestScopeAsCSV?testSuiteId=${this.state.selectedSuite.Id}&userId=${this.state.selectedTester.Id}&simId=${this.state.selectedSim.Id}`;
            this.window.location.href = url;
            this.toastr.info('Download of test scope as CSV file started...');
        };
        // Test File size to ensure we do not allow users to upload files too big
        this.checkFileSizes = (files) => {
            let fac = {
                tooLarge: [],
                validFiles: []
            };
            angular.forEach(files, (file) => {
                // Only files < 10 Mb
                let maxUploadBytes = this.state.maxUploadMb * 1024 * 1024;
                if (file.size <= maxUploadBytes) {
                    fac.validFiles.push(file);
                }
                else {
                    fac.tooLarge.push(file);
                    this.state.showError = true;
                    this.state.errorMsg = ['File is too large. Please select a file less than ', this.state.maxUploadMb, ' MB'].join('');
                }
            });
            return fac;
        };
        // checkFileExtension is a valid extension
        this.checkFileExtension = (file) => {
            let extentions = 'tse,zip,xml,xlsx,xlsm';
            if (extentions.indexOf(file.name.split('.').pop().toLowerCase()) > -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.cancel = () => {
            this.state.showError = false;
            this.state.errorMsg = '';
            let result = this.state;
            this.close({ $value: result });
        };
        this.UploadTestCasesService = UploadTestCasesServiceApi;
        this.UserTestSuiteService = UtpUserTestSuitesServiceApi;
        this.SimTestSuiteService = UtpSimTestSuitesServiceApi;
        this.SettingsService = SettingsService;
        this.timeout = $timeout;
        this.Upload = Upload;
        this.toastr = toastr;
        this.UtpTestSuitesExServiceApi = UtpTestSuitesExServiceApi;
        this.ManageSimulatorServiceApi = ManageSimulatorServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.window = $window;
    }
}
angular.module('app').component('uploadTestCasesModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ProvisionSim/upload-test-cases.tpl.html',
    controllerAs: 'vm',
    controller: UploadTestCasesController
});
